module.exports = __webpack_public_path__ + "static/media/resource-rejuvenation.fa8ee0b5.png";